<template>
  <v-row align="center" justify="center" class="mb-12">
    <v-col cols="12" sm="11" md="8" lg="8" xl="5" xs="12">
      <v-card class="elevation-12">
        <v-row>
          <v-col cols="12" sm="6" md="6" class="d-none d-sm-flex">
            <v-row align="center" justify="center" class="left-side">
              <v-col cols="12" sm="12" class="py-12 px-12">
                <div class="container-custom">
                  <img
                    src="@/assets/images/logo-fif.png"
                    alt="Logo FIF"
                    aspect-ratio="4"
                    contain
                    class="img-bg"
                  />
                  <div class="centered">
                    <v-img
                      src="@/assets/images/logo-fif-text.png"
                      alt="Logo FIF Text"
                      aspect-ratio="3"
                      contain
                    />
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="6" class="py-12 px-12">
            <v-img
              class="d-flex d-sm-none"
              src="@/assets/images/logo-fif-text.png"
              alt="Logo FIF Text"
              aspect-ratio="3"
              contain
            />
            <p
              class="text-center primary--text font-weight-bold mt-5 fgc-middle-dashboard"
            >
              FIFGROUP CARD
            </p>
            <p
              class="text-center primary--text text-capitalized fgc-middle-dashboard-2"
            >
              Middle Dashboard
            </p>
            <template v-if="isExpired">
              <v-card-text>
                <v-form
                  id="expired-form"
                  ref="form"
                  v-model="validExpired"
                  lazy-validation
                  @submit.prevent="submitExpired"
                >
                  <v-row justify="center">
                    <v-col cols="10" class="py-0">
                      <v-text-field
                        data-testid="fieldUsernameLogin"
                        v-model="username"
                        :rules="usernameRules"
                        label="Username"
                        required
                        disabled
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="10" class="py-0">
                      <v-text-field
                        data-testid="fieldOldPasswordLogin"
                        v-model="password"
                        :rules="passwordRules"
                        :append-icon="e2 ? 'visibility' : 'visibility_off'"
                        @click:append="() => (e2 = !e2)"
                        :type="e2 ? 'password' : 'text'"
                        label="Old Password"
                        required
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="10" class="py-0">
                      <v-text-field
                        data-testid="fieldNewPasswordLogin"
                        v-model="newPassword"
                        :rules="newPasswordRules"
                        :append-icon="e3 ? 'visibility' : 'visibility_off'"
                        @click:append="() => (e3 = !e3)"
                        :type="e3 ? 'password' : 'text'"
                        label="New Password"
                        required
                        :error="passwordError != ''"
                        :error-messages="passwordError"
                        :loading="loadingPassword"
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-text class="pt-0">
                <v-row justify="center" dense>
                  <v-col cols="10">
                    <v-card-actions
                      class="rounded"
                      style="background-color: #d6efff"
                    >
                      <v-col cols="12">
                        <v-icon small class="float-left px-1">info</v-icon>
                        <p class="caption ma-0 ml-3">
                          Your password has expired and you need to change it
                          before you sign in to Middle.
                        </p>
                      </v-col>
                    </v-card-actions>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-row cols="8" align="center" justify="center">
                  <v-btn
                    data-testid="buttonLogin"
                    class="button-login elevation-8"
                    :disabled="!validExpired"
                    type="submit"
                    form="expired-form"
                    color="primary"
                    :loading="loadingExpired"
                  >
                    <p class="font-weight-bold ma-auto">
                      Submit
                    </p>
                  </v-btn>
                </v-row>
              </v-card-text>
            </template>
            <template v-else>
              <v-row class="mt-4" justify="center" align="center">
                <v-alert
                  v-model="alert"
                  type="error"
                  border="left"
                  dismissible
                  dense
                  transition="scroll-y-transition"
                >
                  {{ errors }}
                </v-alert>
              </v-row>
              <v-card-text>
                <v-form
                  id="check-login-form"
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  @submit.prevent="onSubmit(username, password)"
                >
                  <v-row justify="center">
                    <v-col cols="10" class="py-0">
                      <v-text-field
                        data-testid="fieldUsernameLogin"
                        v-model="username"
                        :rules="usernameRules"
                        label="Username"
                        required
                      />
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="10" class="py-0">
                      <v-text-field
                        data-testid="fieldPasswordLogin"
                        v-model="password"
                        :rules="passwordRules"
                        label="Password"
                        :append-icon="e1 ? 'visibility' : 'visibility_off'"
                        @click:append="() => (e1 = !e1)"
                        :type="e1 ? 'password' : 'text'"
                        counter
                        required
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-text>
                <v-row cols="8" align="center" justify="center">
                  <v-btn
                    data-testid="buttonLogin"
                    class="button-login elevation-8"
                    :disabled="!valid"
                    type="submit"
                    form="check-login-form"
                    color="primary"
                    :loading="authLoading"
                  >
                    <p class="font-weight-bold ma-auto">
                      Login
                    </p>
                  </v-btn>
                </v-row>
                <p
                  class="display-p text-center font-weight-medium primary--text mt-2"
                >
                  Version {{ version }}
                </p>
              </v-card-text>
            </template>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <img src="@/assets/images/footer.jpg" alt="footer FIF" class="footer-fif" />
  </v-row>
</template>

<script>
import AuthService from "../../services/resources/auth.service";
import { mapGetters } from "vuex";
import { LOGIN } from "@/store/constants/actions.type";
import { SET_ERROR } from "@/store/constants/mutations.type";
import { HOME } from "@/router/names.type";

export default {
  data() {
    return {
      alert: false,
      version: process.env.VERSION ?? null,
      valid: true,
      e1: true,
      e2: true,
      e3: true,
      username: null,
      usernameRules: [
        v => !!v || "Username is required",
        v => !!v || "Username harus diisi",
        v => /^\S{1,}$/.test(v) || "Format username harus sesuai"
      ],
      password: null,
      passwordRules: [v => !!v || "Password is required"],

      newPassword: null,
      newPasswordRules: [
        v => !!v || "Password is required",
        v => this.password !== v || "Password tidak boleh sama"
      ],

      loadingExpired: false,
      validExpired: false,

      passwordError: "",
      loadingPassword: false

      // AuthService: {}
    };
  },
  methods: {
    async onSubmit(username, password) {
      if (this.$refs.form.validate()) {
        try {
          await this.$store.dispatch(LOGIN, {
            username: username,
            password,
            isMember: false
          });

          if (this.$route?.query && this.$route?.query.pathname) {
            if (
              this.$route.query.pathname.includes("login") ||
              this.$route.query.pathname.includes("404") ||
              this.$route.query.pathname.includes("500")
            ) {
              this.$router.replace({ name: HOME });
            } else {
              this.$router.replace(
                this.$route.query.pathname + this.$route.query.search
              );
            }
          } else {
            this.$router.replace({ name: HOME });
          }
        } catch (error) {
          console.error(error);
        }
      } else {
        this.$refs.form.inputs
          .filter(d => d.errorBucket.length > 0)[0]
          .$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
          });
      }
    },
    async validatePassword(data) {
      try {
        this.loadingPassword = true;
        this.createToken(AuthService.cancelReq().source());
        await AuthService.validate(
          { password: data },
          { cancelToken: this.cancelRequest.token }
        )
          .then(({ data }) => {
            const { result } = data;
            if (result == true) {
              this.validPassword = result;
              this.passwordError = "";
            } else {
              this.passwordError = result;
            }
          })
          .catch(error => {
            throw new Error(error);
          })
          .finally(() => (this.loadingPassword = false));
      } catch (err) {
        console.error(err);
      }
    },
    submitExpired() {
      this.loadingExpired = true;
      AuthService.changePasswordExternal({
        oldPassword: this.password,
        newPassword: this.newPassword,
        username: this.username
      })
        .then(({ data: { message, result } }) => {
          if (message == "OK") {
            this.$store.commit("snackbar/setSnack", {
              show: true,
              message: "Password anda berhasil diubah, silahkan login",
              color: "success"
            });
            this.$store.commit(SET_ERROR, null);

            // Reset Password field to null
            this.resetPasswordField();
          } else {
            this.$store.commit("snackbar/setSnack", {
              show: true,
              message: result || "Password anda gagal diubah!",
              color: "error"
            });
          }
        })
        .catch(err => {
          this.$store.commit("snackbar/setSnack", {
            show: true,
            message: "Password anda gagal diubah!",
            color: "error"
          });
          throw new Error(err);
        })
        .finally(() => {
          this.loadingExpired = false;
        });
    },
    resetPasswordField() {
      this.e1 = true;
      this.e2 = true;
      this.e3 = true;
      this.password = null;
      this.newPassword = null;
    },
    goToPage(name) {
      this.$router.replace({ name });
    }
  },
  computed: {
    ...mapGetters(["authLoading"]),
    isExpired() {
      return this.$store.state.errors?.toLowerCase()?.includes("expired");
    },
    errors() {
      return this.$store.state.errors;
    }
  },
  watch: {
    errors(val) {
      if (val) return (this.alert = true);
      return (this.alert = false);
    },
    alert(val) {
      if (!val) return this.$store.commit(SET_ERROR, null);
    },
    newPassword(val) {
      val && this.fetchListDebounce(() => this.validatePassword(val), 1000);
    }
  },
  beforeRouteEnter(_to, _from, next) {
    next(vm => {
      if (vm.$store.getters.isAuthenticated) {
        next({ name: "home" });
      } else {
        next();
      }
    });
  }
};
</script>
<style>
/* Container holding the image and the text */

.container-custom {
  position: relative;
  text-align: center;
}

/* Centered text */
.centered {
  position: absolute;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.img-bg {
  opacity: 0.1;
  width: 80%;
}

.left-side {
  height: 500px;
}

.img-fifgroup-login {
  width: 100%;
  height: 100%;
}

.button-login {
  width: 70%;
}

.footer-fif {
  position: absolute;
  width: 100%;
  height: 10%;
  bottom: 0;
  left: 0;
  right: 0;
}

@media only screen and (max-width: 600px) {
  .display-img {
    display: block;
  }

  .fgc-middle-dashboard {
    font-family: "Roboto", sans-serif;
    font-size: 14pt;
  }

  .fgc-middle-dashboard-2 {
    font-family: "Roboto", sans-serif;
    font-size: 12pt;
  }
}

@media only screen and (min-width: 601px) {
  .display-img {
    display: none;
  }

  .fgc-middle-dashboard {
    font-family: "Roboto", sans-serif;
    font-size: 20pt;
  }

  .fgc-middle-dashboard-2 {
    font-family: "Roboto", sans-serif;
    font-size: 12pt;
  }
}
</style>
